import { gql } from "@apollo/client";

export const listInstantWins = gql`
  query ListInstantWins($filter: InstantWinFilterInput, $page: Int, $size: Int) {
    listInstantWins(filter: $filter, page: $page, size: $size) {
      total
      items {
        id
        title
        startsAt
        endsAt
        instantWinStatus
        rollover
        fallback
        metadata
        createdAt
        updatedAt
      }
    }
  }
`;

export const findInstantWinById = gql`
  query FindInstantWinById($id: String) {
    findInstantWinById(id: $id) {
      id
      title
      startsAt
      endsAt
      instantWinStatus
      rollover
      fallback
      metadata
      createdAt
      updatedAt
    }
  }
`;

export const listPrizeSeeds = gql`
  query ListPrizeSeeds(
    $instantWinId: UUID!
    $page: Int
    $size: Int
    $filter: PrizeSeedFilterInput
  ) {
    listPrizeSeeds(
      instantWinId: $instantWinId
      page: $page
      size: $size
      filter: $filter
    ) {
      total
      items {
        id
        instantWinId
        seedTime
        rewardId
        rewardQuantity
        rewardDescription
        claimedAt
        claimedStatus
        profileId
        metadata
        createdAt
        updatedAt
      }
    }
  }
`;

export const findInstantWinSummaryById = gql`
  query FindInstantWinSummaryById($id: String) {
    findInstantWinById(id: $id) {
      id
      title
      prizeSeedSummary {
        rewardId
        rewardDescription
      }
    }
  }
`;
